import React from "react";
import LocationComponent from "@/components/Common/Location";
import * as s from "./index.module.scss";

const Location = () => {
  return (
    <section className={`${s.about_location}`}>
      <LocationComponent />
    </section>
  );
};

export default Location;
